<mat-expansion-panel [expanded]="isExpanded">
  <mat-expansion-panel-header>{{title}}</mat-expansion-panel-header>
  <app-list-opinions [response]="response"
                     [lastInstructionState]="lastInstructionState"
                     [displayGestionnaire]="false"></app-list-opinions>
</mat-expansion-panel>
